import { BehaviorSubject } from 'rxjs';

export const isDownLoadEnabledSubject$ = new BehaviorSubject(false);

export const getIsDownloadEnabled$ = () => isDownLoadEnabledSubject$;
export const setIsDownloadEnabled$ = (isDownloadEnabled: boolean) => {
  isDownLoadEnabledSubject$.next(isDownloadEnabled);
};
